import React, { Component, ReactNode } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import ErrorTryAgain from '@/shahrzad-assets/shared-screens/ErrorTryAgain';

const ErrorBoundary = ({ children }: {children: ReactNode}) => {
    return <SentryErrorBoundary
        fallback={({ resetError })=>{
            return <>
                <ErrorTryAgain buttonClick={()=>window.location.reload()} />
            </>
        }}
    >
        {children}
    </SentryErrorBoundary>
}

export default ErrorBoundary;